export default __webpack_public_path__ + "static/media/AG12.5b0647c3.mp3";